import { serviceApi } from '~/api';
import qs from 'qs';

export const config = {
  PostcodeSearchForm: {
    title: 'Property Address',
    subtitle: 'Please enter the postcode of the property where you want us to measure for our fitting service.',
    AddressDropdown: {
      buildDefaultOptionLabel: addressCount => `Please select the property address from the ${addressCount} found:`,
      addressFormLinkLabel: 'I can\'t see the property address in the list',
    },
    checkPostcodeAvailability: (postcode, appointmentTypeId) => serviceApi.fetch(`availability?${qs.stringify({ postcode, appointmentTypeId })}`, {}),
    errorMessageForUnsupportedPostcode: {
      type: 'NO_ADDRESSES_FOUND_ERROR',
      description: (
        <p>
          {`We do not offer this service in your area, please contact us on `}
          <a href="tel:0345 608 0850">0345 608 0850</a>
          {` or email `}
          <a href="mailto: furnishings.scheduling@johnlewis.co.uk">furnishings.scheduling@johnlewis.co.uk</a>
          {` to discuss other options`}
        </p>
      ),
    },
  },
};
